<!--作业记录-->
<template>
    <div class="el-JobRecord">
        <el-row class="page_content">
            <h1 class="head_title_white">
                <el-button type="primary" @click="closePage">返 回</el-button>
            </h1>
            <div class="bg_"></div>
            <el-row style="padding: 20px;">
                <h1 style="font-size: 20px;">您参加作业《{{courseName}}》的情况如下：</h1>
                <el-table
                :data="tableData"
                border
                style="width: 100%;">
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="作业次数">
                    <template slot-scope="scope">
                        第 {{indexNo(scope.$index)}} 次作业
                    </template>
                </el-table-column>
                <el-table-column
                    prop="homeworkStudentAddTime"
                    header-align="center"
                    align="center"
                    label="开考时间">
                </el-table-column>
                <el-table-column
                    prop="homeworkFraction"
                    header-align="center"
                    align="center"
                    label="得分" width="200">
                    <template slot-scope="scope">
                        <template v-if="!$isEmpty(scope.row.homeworkFinishTime)">
                            <template v-if="getNowTime - new Date(scope.row.homeworkFinishTime).getTime() > 60000">
                                <el-link :underline="false" type="danger">{{scope.row.homeworkFraction}}</el-link>
                            </template>
                            <template v-else>
                                <el-link :underline="false" type="info">正在统计</el-link>
                            </template>
                        </template>
                        <template v-else>
                            <el-link :underline="false" type="primary">0</el-link>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    align="center"
                    label="操作" width="200">
                    <template slot-scope="scope">
                        <el-link :underline="false" :disabled ="$isEmpty(scope.row.homeworkFinishTime)" type="success" @click="viewAnswerSheet(scope.$index)">查看答卷</el-link>
                        <el-link :underline="false" :disabled ="!$isEmpty(scope.row.homeworkFinishTime)" type="success" style="margin-left:20px;" @click="continueTheExam(scope.$index)">继续作业</el-link>
                    </template>
                </el-table-column>
            </el-table>
            </el-row>
        </el-row>
    </div>
</template>
<script>
import {getStorageKeyForRoleTag, openWithRoleTag} from "../../common/ulit";

export default {
  name: "JobRecord",
  data() {
    return {
      homeworkId:this.$route.query.homeworkId,
      tableData: [],
      courseName:this.$Base64.decode(this.$route.query.courseName),
      getNowTime:"", //当前后端时间
      setInt:null,
      setInt1:null,
    };
  },
  created() {
        if(this.setInt != null){
            clearInterval(this.setInt);
        }
        if(this.setInt1 != null){
            clearInterval(this.setInt1);
        }
    if(this.$isEmpty(this.homeworkId)){
      jquerythis.$message({
         message: "数据丢失，请返回上一页！",
         type: 'warning'
      });
    }else{
        this.getNowDate();
      this.getHomeworkLog();
      localStorage.removeItem(getStorageKeyForRoleTag('homeworkName_tag_'));
      let this_ = this;
      this.setInt1 = setInterval(function() {
        if(localStorage.getItem(getStorageKeyForRoleTag('homeworkName_tag_')) == 1){
          localStorage.removeItem(getStorageKeyForRoleTag('homeworkName_tag_'));
          this_.getHomeworkLog();
        }
      }, 1000);
    }
  },
  methods: {
    indexNo(i){
        return this.tableData.length - i;
    },
    closePage(){
        this.$router.go(-1);
      // window.location.href="about:blank";
      // window.close();
    },
    getHomeworkLog(){ //获取作业记录
      this.$store.dispatch("user/getHomeworkLog",{homeworkId:this.homeworkId}).then((ret) => {
        if (ret.code != 0 && ret.code != '0') {
          this.$message({
             message: ret.msg,
             type: 'warning'
          });
        }else{
          this.tableData = ret.data;
        }
      });
    },
    viewAnswerSheet(index){ //查看答卷
        if(this.getNowTime - new Date(this.tableData[index].homeworkFinishTime).getTime() > 60000){
            localStorage.setItem(getStorageKeyForRoleTag('homeworkName_examination'),this.courseName + "   作业" + this.$chineseNum(this.indexNo(index) - 1));
              // this.$router.push({name:'ViewAnswerSheet',query:{homeworkStudentId:this.tableData[index].homeworkStudentId}});
            openWithRoleTag(window.location.origin + '/ViewAnswerSheet?homeworkStudentId='+this.tableData[index].homeworkStudentId+"&courseName="+this.$Base64.encode(this.courseName) + "   作业" + this.$chineseNum(this.indexNo(index) - 1));
        }else{
            this.$message({
                message: "正在统计，请稍后！",
                type: 'warning'
            });
        }
        },
    continueTheExam(index){ //继续考试
      localStorage.setItem(getStorageKeyForRoleTag('homeworkName_examination'),this.courseName + "   作业" + this.$chineseNum(this.indexNo(index) - 1));
      // this.$router.push({name:'Examination',query:{homeworkId:this.tableData[index].homeworkId}});
        openWithRoleTag(window.location.origin + '/Examination?homeworkStudentId='+this.tableData[index].homeworkStudentId+"&courseName="+this.$Base64.encode(this.courseName) + "   作业" + this.$chineseNum(this.indexNo(index) - 1));
    },
    getNowDate(){
      const this_ = this;
      this.$store.dispatch("getNowTime").then((res) => {
        if(res.code == 0){
          this.getNowTime = new Date(res.data).getTime();
          this.setInt = setInterval(()=>{
            this.getNowTime = Number(this.getNowTime) + Number(1000);
          },1000);
        }else{
          this.getNowTime = this.$getNewDate();
          this.setInt = setInterval(()=>{
            this.getNowTime = new Date(this.getNowTime).getTime() + Number(1000);
          },1000);
        }
    	}).catch(function(error) {
    		this_.getNowTime = this_.$getNewDate();
            this_.setInt = setInterval(()=>{
              this_.getNowTime = new Date(this_.getNowTime).getTime() + Number(1000);
            },1000);
    	});
    }
  },
    beforeDestroyed() {
        if(this.setInt != null){
            clearInterval(this.setInt);
        }
        if(this.setInt1 != null){
            clearInterval(this.setInt1);
        }
    },
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-JobRecord{
    .head_title_white{
        text-align: right;
        margin-bottom:0;
        padding: 10px 30px;
    }
    .bg_{
        height: 10px;
        background-color: @mainBg;
        margin: 0 -20px;
    }
    .learning_img{
        width: 280px;height: 220px;border: 1px solid rgb(238, 238, 238);float: left;margin-right: 20px;
    }
    .el-main{
        min-width: 1200px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/JobRecord.vue